import type { LineMetric } from '@meitu/x-design-text';
import type { TextRenderSpanRange } from '../types';

/**
 * 根据 snapshot 字形纵坐标查找所属视觉行。
 *
 * @param lines - 快照中的有序视觉行指标。
 * @param y - 字形基线纵坐标。
 * @returns 命中的视觉行索引；没有视觉行时返回 -1。
 */
export const findLineIndex = (lines: readonly LineMetric[], y: number): number => {
    if (lines.length === 0) return -1;
    if (y < lines[0].top) return 0;
    const index = lines.findIndex((line) => y >= line.top && y < line.bottom);
    return index >= 0 ? index : lines.length - 1;
};

/**
 * 使用二分查找读取 UTF-8 字节偏移所属的富文本分段。
 *
 * @param ranges - 按起始字节升序排列的 span 范围。
 * @param byteStart - 当前指令或字形的起始字节偏移。
 * @returns 命中的 span 索引；未命中时返回 -1。
 */
export const findSpanIndex = (ranges: readonly TextRenderSpanRange[], byteStart: number): number => {
    let left = 0;
    let right = ranges.length - 1;
    while (left <= right) {
        const middle = Math.floor((left + right) / 2);
        const range = ranges[middle];
        if (byteStart < range.start) right = middle - 1;
        else if (byteStart >= range.end) left = middle + 1;
        else return middle;
    }
    return -1;
};
